module.exports = __webpack_public_path__ + "img/payroll.9f66754e.svg";